export const COUNT_QUESTION_IN_CATEGORIES = 10;
export const COOFICIENT_CATEGORIES = {
  author: 'author',
  picture: 'picture'
};
export const COUNT_CATEGORIES = 12;

